import React from 'react'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { useSelector } from 'react-redux'
import { BottomSheet } from '@src/components'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { AppStackParamList, RootStackParamList } from '@src/navigation/types'
import Intercom from '@src/utils/intercom'
import { getCoachDescriptor } from '@src/utils'
import { userSelector } from '@src/selectors/app'
import { NutritionistPhotoIcon } from '@screens/NutritionistHub/components/NutritionistPhotoIcon.tsx'
import { Debug } from '@config'
import { useFeeProduct } from '@screens/NutritionistHub/hooks/useFeeProduct.ts'
import { useShowIntercomDisabledModal } from '@src/utils/hooks'
import { useChatConversation } from '@src/hooks/useChatConversation'

export const LateRescheduleVideoCallModal = () => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>()
  const route = useRoute<RouteProp<AppStackParamList, 'LateRescheduleVideoCallModal'>>()
  const { videoCallId, appointmentKind, lateRescheduleFeeProduct, coachingKind } = route.params

  const chatConversation = useChatConversation(coachingKind)
  const user = useSelector(userSelector)
  const feeProduct = useFeeProduct(lateRescheduleFeeProduct)
  const showIntercomDisabledModal = useShowIntercomDisabledModal()
  const coachDescriptor = getCoachDescriptor(user)

  const onReschedulePress = () => {
    navigation.replace('CallScheduling', {
      appointmentKind,
      appointmentId: videoCallId,
      allowBackNavigation: true,
      feeProduct,
    })
  }

  const goToIntercom = () => {
    if (!Debug.shouldEnableIntercom()) {
      showIntercomDisabledModal()
      return
    }

    if (chatConversation) {
      Intercom.showIntercomConversation(chatConversation.intercomId)
    } else {
      Intercom.showIntercomMessenger({ source: 'NutritionistHub' })
    }
  }

  return (
    <BottomSheet
      primaryButton={{ text: 'Confirm fee and Reschedule', onPress: onReschedulePress }}
      secondaryButton={{ text: `Message your ${coachDescriptor}`, onPress: goToIntercom }}
      buttonDirection="column-reverse"
    >
      <NutritionistPhotoIcon style={styles.nutritionistPhoto} />
      <Text style={styles.title} type="title-2">
        Need to Reschedule?
      </Text>
      <Text style={styles.content} type="regular">
        We get it, life happens.
      </Text>
      <Text style={styles.content} type="regular">
        Rescheduling within 24hrs of the call is subject to a ${feeProduct?.price || ''} fee as your
        {` ${coachDescriptor} reserved this time just for you.`}
      </Text>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  title: {
    textAlign: 'center',
    paddingTop: 16,
    paddingBottom: 16,
  },
  content: {
    textAlign: 'center',
    paddingBottom: 16,
  },
  nutritionistPhoto: {
    alignSelf: 'center',
  },
})
